import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getYear } from "../../../utils/date/getters";
import Button from "../../Button";
import DropdownMenu from "../../DropdownMenu";
const DEFAULT_YEAR = 2015;
const years = Array.from(Array(Math.abs(getYear(new Date()) + 0 - DEFAULT_YEAR) + 1), (_, i) => DEFAULT_YEAR + i);
const DatePickerYears = ({ selectedYear, setSelectedYear }) => {
    return (_jsxs(DropdownMenu, { children: [_jsx(DropdownMenu.Trigger, { asChild: true, children: _jsx(Button, { size: "condensed", variant: "outlined", color: "secondary", children: selectedYear }) }), _jsx(DropdownMenu.Content, { align: "start", portal: false, children: years.map((year) => (_jsx(DropdownMenu.Item, { onClick: () => setSelectedYear(year), children: year }, year))) })] }));
};
export default DatePickerYears;
